import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=29e3cddd"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"
import style0 from "./tags.vue?vue&type=style&index=0&id=29e3cddd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports